// extracted by mini-css-extract-plugin
module.exports = {"heartRateBarsStyle":"szv3cn_GJXaBzNlklz-A5"};